"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Index = void 0;
var _react = _interopRequireDefault(require("react"));
var _DatePicker = _interopRequireDefault(require("./DatePicker"));
var _DateTimePicker = _interopRequireDefault(require("./DateTimePicker"));
var _excluded = ["pickerType"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
var Index = props => {
  var {
      pickerType
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, pickerType === 'date' ? /*#__PURE__*/_react.default.createElement(_DatePicker.default, rest) : /*#__PURE__*/_react.default.createElement(_DateTimePicker.default, rest));
};
exports.Index = Index;
var _default = exports.default = Index;